module.exports = __webpack_public_path__ + "static/media/Creed.ee51db89.png";